module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 7
// module chunks = 0